module.exports = __webpack_public_path__ + "static/media/AM.8a0a949f.jpg";